import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBracketsRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M3.9 2.8Q2.6 2.9 2.5 4v8.3q.1 1.2 1.4 1.3h1.5a.6.6 0 1 0 0-1.1H4l-.2-.2V4l.2-.2h1.5a.6.6 0 1 0 0-1.1zm8.2 0h-1.5a.6.6 0 1 0 0 1.1H12l.2.2v8.3l-.2.2h-1.5a.6.6 0 1 0 0 1.2H12q1.3-.2 1.4-1.4V4q-.1-1.2-1.4-1.3"
	})
});
export default SvgBracketsRegularIcon;
